
import styled from 'styled-components';

// export const CloudCertModalOverlay = styled.div`
//   height: 40vh;
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background-color: #ca1720;
// `;

export const CloudCertModalOverlay = styled.div`
  height: 40vh;
  width: 100%;
  display: block;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 5px;
   @media screen and (max-width: 600px) and (orientation: portrait) {
    height: auto;
    width: auto;
    margin: 5px;
    padding: 5px;
    padding-bottom: 25px;
  }
`;